import { Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { FC, useCallback } from 'react';

const ApiKeyDatePicker: FC<React.PropsWithChildren<ApiKeyDatePickerProps>> = ({
  title,
  date,
  setDate,
}) => {
  const onChange = useCallback(
    (newValue: dayjs.Dayjs | null) => {
      setDate(newValue);
    },
    [setDate],
  );

  return (
    <div>
      <Typography mb={0.5} color='text.primary'>
        {title}
      </Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          value={date}
          disablePast
          minDateTime={dayjs(Date.now())}
          onChange={onChange}
          renderInput={params => <TextField {...params} />}
        />
      </LocalizationProvider>
    </div>
  );
};

export interface ApiKeyDatePickerProps {
  title: string;
  date: dayjs.Dayjs | null;
  setDate: React.Dispatch<React.SetStateAction<dayjs.Dayjs | null>>;
}

export default ApiKeyDatePicker;
